import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import FlexibleWorkspace from '../components/FlexibleWorkspace';

const FlexibleWorkspacePage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <div className="pt-8">
        <FlexibleWorkspace />
      </div>
      <Footer />
    </div>
  );
};

export default FlexibleWorkspacePage;